import { gql } from '@apollo/client';

export const ParagraphInfolinoPOIsFragment = gql`
  fragment ParagraphInfolinoPOIsFragment on ParagraphInfolinoPOIs {
    id
  }
`;
